
import { Component, Prop, toNative, Vue, Ref } from 'vue-facing-decorator';
import { Popup } from '@progress/kendo-vue-popup';
import { Root } from '@/main';

interface KebabAction {
  id: number;
  text: string;
}

let activeMenuClose: (() => void) | null = null;

@Component({ components: { Popup } })
class KebabMenu extends Vue {
  @Prop() dataItem!: any;
  @Ref('button') readonly buttonRef!: HTMLElement;

  private show = false;

  private localActions: KebabAction[] = [
    { id: 0, text: 'Edit participant' },
    { id: 1, text: 'Delete from this event' },
  ];

  private onDocumentClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    // Ignore clicks inside the kebab popup (teleported to body by Kendo)
    if (target.closest('.kebab-popup') || target.closest('.kebab-container')) {
      return;
    }
    this.closeMenu();
  };

  private onClick(event: Event) {
    event.stopPropagation();

    if (this.show) {
      this.closeMenu();
      return;
    }

    activeMenuClose?.();

    this.show = true;
    activeMenuClose = () => this.closeMenu();

    // Delay listener attachment so the current click event doesn't immediately close
    this.$nextTick(() => {
      document.addEventListener('click', this.onDocumentClick, true);
    });
  }

  private closeMenu() {
    this.show = false;
    activeMenuClose = null;
    document.removeEventListener('click', this.onDocumentClick, true);
  }

  private onClickAction(action: KebabAction) {
    if(action.id === 1) {
      Root.emit('delete-participant');
    } else {
      Root.emit('edit-participant', {
        dataItem: this.dataItem,
        action: action.id,
      });
    }
    this.closeMenu();
  }

  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick, true);
    if (this.show) {
      activeMenuClose = null;
    }
  }
}

export default toNative(KebabMenu);
